"use strict";

var _toConsumableArray = require("/tmp/fuelmanmaintenance-production/11/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _classCallCheck = require("/tmp/fuelmanmaintenance-production/11/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/tmp/fuelmanmaintenance-production/11/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

module.exports =
/*#__PURE__*/
function () {
  function Interceptor(API) {
    var _this = this;

    var interceptableMethods = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

    _classCallCheck(this, Interceptor);

    this.interceptors = [];
    if (!API) throw new Error('API should be passed to the Interceptor');
    if (interceptableMethods.length === 0) throw new Error('no methods were added to interceptableMethods');
    interceptableMethods.forEach(function (methodName) {
      var methodFn = API[methodName];

      API[methodName] = function () {
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        return _this.interceptedMethod.apply(_this, [methodFn.apply(void 0, args)].concat(args));
      };
    });
  }
  /* eslint-disable promise/prefer-await-to-then */


  _createClass(Interceptor, [{
    key: "interceptedMethod",
    value: function interceptedMethod(methodFn) {
      var interceptors = this.interceptors;
      var reversedInterceptors = interceptors.slice().reverse();

      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      var promise = Promise.resolve(args); // Register request interceptors

      interceptors.forEach(function (_ref) {
        var request = _ref.request,
            requestError = _ref.requestError;
        if (typeof request === 'function') promise = promise.then(function (args) {
          return request.apply(void 0, _toConsumableArray([].concat(args)));
        });
        if (typeof requestError === 'function') promise = promise.catch(requestError);
      }); // Register methodFn call

      if (typeof methodFn === 'function') promise = promise.then(function (args) {
        return methodFn.apply(void 0, _toConsumableArray([].concat(args)));
      }); // Register response interceptors

      reversedInterceptors.forEach(function (_ref2) {
        var response = _ref2.response,
            responseError = _ref2.responseError;
        if (typeof response === 'function') promise = promise.then(response);
        if (typeof responseError === 'function') promise = promise.catch(responseError);
      });
      return promise;
    }
    /* eslint-enable promise/prefer-await-to-then */

  }, {
    key: "register",
    value: function register(interceptor) {
      var _this2 = this;

      this.interceptors.push(interceptor);
      return function () {
        return _this2.unregister(interceptor);
      };
    }
  }, {
    key: "unregister",
    value: function unregister(interceptor) {
      var index = this.interceptors.indexOf(interceptor);
      if (index >= 0) this.interceptors.splice(index, 1);
    }
  }, {
    key: "clear",
    value: function clear() {
      this.interceptors = [];
    }
  }]);

  return Interceptor;
}();